import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const tenantRatioConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default tenantRatioConfigEntity
